var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSortAscending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13 6a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h9a1 1 0 0 0 1-1m3.6 2.07-2.064 1.964a.93.93 0 0 1-1.272 0 .83.83 0 0 1 0-1.211l3.599-3.428a.93.93 0 0 1 1.274 0l3.6 3.428a.83.83 0 0 1 0 1.211.93.93 0 0 1-1.273 0L18.4 8.07v10.074c0 .474-.402.857-.9.857s-.9-.383-.9-.857zM9 18a1 1 0 0 0-1-1H3a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1m1-7a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2z",
  clipRule: "evenodd"
})));
export default SvgGemSortAscending;